export default function setLoggedIn(state, action) {
    const user = {
        email: action.email
    };

    return {...state, user};
}